import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../src/components/layout/MainLayout";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";
import SuicideIntentList from "../pages/Phase-04/SuicideIntent/SuicideIntentList";
import { useDispatch, useSelector } from "react-redux";
import { fetchSuicideIntentAssessments, deleteSuicideIntentAssessment } from "../store/slices/suicideIntentSlice";
import Swal from "sweetalert2";

const SuicideIntents = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { suicideIntentAssessments, isLoading } = useSelector(
        (state) => state.suicideIntent
    );

    useEffect(() => {
        const loadAssessments = async () => {
            try {
                const result = await dispatch(fetchSuicideIntentAssessments()).unwrap();
                console.log(result); // <- this will now be the array
            } catch (error) {
                console.error("Failed to fetch", error);
            }
        };

        loadAssessments();
    }, [dispatch]);

    const handleAdd = () => navigate("/phase04/suicide-intent/add");
    const handleEdit = (id) => navigate(`/phase04/suicide-intent/edit/${id}`);
    const handleDelete = (id) => dispatch(deleteSuicideIntentAssessment(id));

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body p-0">
                        <SuicideIntentList
                            assessments={suicideIntentAssessments}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SuicideIntents;
